// extracted by mini-css-extract-plugin
module.exports = {"pnlBox":"styles_pnlBox__YX8xe","pnl":"styles_pnl__V5lT5","symbol":"styles_symbol__G9GW2","asset":"styles_asset__wdf67"};